import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import api from "utils/api";
import { nextPageRotation } from "components/SmartSurveyor/ReviewPage/FloorPlanPanelWrapper/createDisplayTransform";
import type { UsePageRotation } from "./types";

export const usePageRotation: UsePageRotation = ({
  selectedPlan,
  pageIndex,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [isRotating, setIsRotating] = useState(false);

  const rotation = selectedPlan?.rotationByPageIndex.get(pageIndex) ?? 0;

  const rotateClockwise = useCallback(async () => {
    if (!selectedPlan || isRotating) return;
    const pageId = selectedPlan.pageIdByIndex.get(pageIndex);
    if (pageId === undefined) return;

    const nextRotation = nextPageRotation(rotation);
    setIsRotating(true);
    try {
      await api.updateQuantitySurveyorPageRotation({
        pageId,
        rotation: nextRotation,
      });
      onSuccess({
        floorPlanId: selectedPlan.floorPlanId,
        pageIndex,
        rotation: nextRotation,
      });
    } catch {
      toast.error(t("smartSurveyor.pageRotation.failedToSave"));
    } finally {
      setIsRotating(false);
    }
  }, [selectedPlan, isRotating, pageIndex, rotation, onSuccess, t]);

  return { rotation, rotateClockwise, isRotating };
};
